import ApiService from '@/core/services/api.service';

const storeSearchMixin = {
  mounted() {
    this.fetchStore().then();
  },
  data() {
    return {
      storeValues: [],
      optionsStore: [
        {
          data: [],
        },
      ],
    };
  },
  methods: {
    fetchStore: function () {
      this.optionsStore = [];
      ApiService.setHeader();
      return ApiService.get(`stores/get-by-user`)
        .then((response) => {
          const payload = response.data && response.data.data;
          const stores = (payload && payload.stores) || [];
          stores.forEach((element) => {
            this.optionsStore.push({
              id: element.id,
              name: element.name,
              shortName: element.shortName,
              checked: false,
            });
          });
          if (this.optionsStore.length === 1) {
            const only = this.optionsStore[0];
            only.checked = true;
            this.storeValues = [only];
          }
        })
        .finally(() => {
          if (typeof this.afterFetchStore === 'function') {
            this.afterFetchStore();
          }
        });
    },
  },
};
export default storeSearchMixin;
